<template>
  <div class="text-center">
    <div class="container container-links">
      <div style="margin-bottom: 32px">
        <div class="img-empresa"><img :src="empresa.url_imagem || (base_cdn + '/static/imgs/default.png')" alt="Logo Empresa" class="shadow-sm"></div>
        <h4 class="font-weight-bold mb-1">{{empresa.nome_fantasia}}</h4>
        <div class="small">
          <icon class="fi-2" name="address" full="true" size="15"/> {{empresa.nome_cidade}} - {{empresa.sigla_estado}}
        </div>
      </div>
      <a :href="empresa.site" class="btn btn-links btn-primary">
        <icon class="fi-2" name="sacola" full="true" size="28"/> Peça pelo App
      </a>
      <a :href="'https://api.whatsapp.com/send?phone=55' + empresa.whatsapp" v-if="empresa.whatsapp" target="_blank" class="btn btn-links btn-primary">
        <span><svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 512 512" fill="#ffffff"><path d="M232.5 17.1c-13.4 1.3-34.4 5.6-48.5 10.1C67.2 64.5-2.7 181.9 20.6 302c4.9 25.3 17.1 56.8 30.1 78l4 6.5-19.3 45c-11.7 27.2-19.3 46.3-19.4 48.3-.1 10.4 10.1 18.3 20 15.5 1.9-.6 22.9-9.3 46.6-19.5l43.2-18.5 5.3 3.5c3 1.9 12.1 6.7 20.2 10.7 107 52.9 237.5 17.4 304.2-82.5 63.6-95.3 51-221.4-30-302.5-51-51-120.8-76.1-193-69.4m-42.7 114.3c1.5.8 10.2 9 19.4 18.3 18.3 18.5 19.8 20.9 17.7 28.8-.8 3.1-3.5 6.4-11.7 14.8L204.5 204l.2 5.8c.4 14.9 12.9 35.6 35.2 58.6 23.1 23.7 46.8 38.5 62.3 38.9l5.8.2 10.8-10.8c12-12 15.1-13.6 22.7-11.6 3.3.9 7.2 4.3 21.7 18.7 15.1 15.1 17.8 18.3 18.8 22.1 2.5 9.6-1.4 16.6-19.3 33.8-15.9 15.3-25 18.9-47.7 18.7-15.2-.1-25.6-2.3-41-8.8-46.9-19.8-105.9-77.2-128.6-125.1-14-29.5-16.1-58-5.8-79.2 4.4-9.1 28.8-33.1 35.8-35.3 3.9-1.2 10.8-.5 14.4 1.4"/></svg></span>
        Chame no WhatsApp
      </a>
      <a :href="googleMapsUrl" v-if="empresa.tipo_delivery !== '3' && empresa.json_config && empresa.json_config.endereco_empresa === '1'" target="_blank" rel="noopener" class="btn btn-links btn-primary">
        <icon class="fi-2" name="address" full="true" size="28"/> Como chegar
      </a>
      <a :href="ios" v-if="ios" target="_blank" class="btn btn-links btn-primary">
        <span class="fa fa-apple"></span>
        Baixar App iOS
      </a>
      <a :href="android" v-if="android" target="_blank" class="btn btn-links btn-primary">
        <span><svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 512 512" fill="#ffffff"><path d="M67.4 1.5c-7.5 1.6-17.9 5.7-17.9 7 .1 1.2 230.6 214.3 232 214.4.6.1 18.5-17.4 39.8-38.7l38.9-38.9-123.5-68.2c-68-37.4-126.4-69.5-130-71.1-12-5.7-26.5-7.3-39.3-4.5M21.6 37C15.8 50 16 39 16 256c0 216.3-.2 206.3 5.4 218.6 1.4 3 2.9 5.4 3.3 5.4s53.4-52.6 117.6-116.8l116.8-116.8-116.7-107.7C78.2 79.5 25.3 31 25 31c-.4 0-1.9 2.7-3.4 6m325.2 166.7-41.6 41.8 37.1 34.2c20.5 18.8 43.6 40.1 51.4 47.3l14.3 13.2 27.7-15.3c15.3-8.4 30.3-16.9 33.4-19C485.3 295 496 275.2 496 256s-11.1-39.6-27.3-50.3c-6.6-4.3-78-43.7-79.3-43.7-.5 0-19.7 18.8-42.6 41.7M165 385.5C71.7 478.8 47.8 503.2 49 504c2.7 1.7 14.4 5.8 19.8 6.9 11.7 2.4 28.4.1 39.5-5.5 7.4-3.8 268-147.5 269-148.4.7-.6-37.3-36.2-92.3-86.6l-2.6-2.3z"/></svg></span>
        Baixar App Android
      </a>
      <div style="margin-top: 42px">
        <a :href="empresa.url_instagram" target="_blank" class="btn btn-outline-primary btn-social" v-if="empresa.url_instagram"><i class="fa fa-instagram" style="font-size: 24px"></i></a>
        <a :href="empresa.url_facebook" target="_blank" class="btn btn-outline-primary btn-social" v-if="empresa.url_facebook"><i class="fa fa-facebook" style="font-size: 24px"></i></a>
      </div>
    </div>
    <div class="container container-links-footer">
      <ads-le-card class="mb-4 links-footer"/>
    </div>
  </div>
</template>

<script>
  import AdsLeCard from "../components/AdsLeCard";
  import Icon from "../components/Icon";

  export default {
    name: 'Share',
    components: {Icon, AdsLeCard},
    data() {
      return {
        load: true,
        url: '',
        android: null,
        ios: null
      }
    },

    mounted() {
      this.url = this.$helpers.getUrlApp(this.$route.params.id || '');
      this.android = this.envEmpresa.VUE_APP_ANDROID && this.envEmpresa.VUE_APP_ANDROID_PACKAGE_NAME ? 'https://play.google.com/store/apps/details?id=' + this.envEmpresa.VUE_APP_ANDROID_PACKAGE_NAME : null
      this.ios = this.envEmpresa.VUE_APP_IOS_APP ? 'https://apps.apple.com/br/app/' + this.envEmpresa.VUE_APP_IOS_APP : null;
    },

    computed: {
      googleMapsUrl() {
        const endereco = [
          this.empresa.endereco,
          this.empresa.numero,
          this.empresa.complemento,
          this.empresa.bairro,
          this.empresa.nome_cidade,
          this.empresa.sigla_estado
        ].filter(Boolean).join(', ');

        return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(endereco)}`;
      },

      empresa() {
        return this.$store.state.empresa;
      }
    }
  }
</script>
<style scoped>
  .btn-links {
    text-align: center;
    display: block;
    border-radius: 12px;
    position: relative;
    padding: 18px 0;
    width: 97%;
    margin: 0 auto 12px;
    transition: 0.3s;
  }

  .btn-links span {
    position: absolute;
    left: 18px;
    top: 16px;
  }

  .btn-links span.fa {
    font-size: 28px;
  }

  .btn-links:hover {
    box-shadow: var(--shadow-lg);
    width: 100%;
  }

  .btn-social {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    padding: 0;
    width: 52px;
    height: 52px;
    margin: 0 6px;
    transition: 0.3s;
  }

  .btn-social i {
    color: var(--lecard-primary);
    line-height: 1;
  }

  .btn-social:hover i {
    color: #ffffff;
  }

  .btn:hover {
    box-shadow: var(--shadow-lg);
  }

  .container-links {
    padding-top: 32px;
    max-width: 500px;
  }

  .container-links-footer {
    max-width: 500px;
  }

  .links-footer {
    width: 97%;
    margin-top: 56px;
    padding-right: 0;
    padding-left: 0;
  }

  .img-empresa {
    width: 100px;
    height: 100px;
    background-color: #F4F5F7;
    border: 6px solid #F4F5F7;
    border-radius: 12px;
    position: relative;
    margin: 0 auto 24px;
  }

  .img-empresa img {
    background-color: #ffffff;
    border-radius: 12px;
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }
</style>
